export class PermissionDetails {
    constructor(public activity: string, public displayName: string, public isEnabled: boolean) {
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/accessManagement/permission-details.ts
 **/